module.exports = __webpack_public_path__ + "static/img/applyImg1.461e1a08.png";